import React from 'react';
import { components } from 'react-select-v3';

export const MenuList = (props) => {
  const { selectProps } = props;
  const { name } = selectProps || {};
  return (
    <components.MenuList {...props}>
      <div data-testid={`${name}_menu`}>{props.children}</div>
    </components.MenuList>
  );
};
